var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-view" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-form",
            {
              ref: "nodeForm",
              staticClass: "node-form",
              attrs: {
                "label-width": "150px",
                model: _vm.taskForm,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Task ID") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Task ID", disabled: "" },
                    model: {
                      value: _vm.taskForm._id,
                      callback: function($$v) {
                        _vm.$set(_vm.taskForm, "_id", $$v)
                      },
                      expression: "taskForm._id"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Status") } },
                [
                  _c("status-tag", { attrs: { status: _vm.taskForm.status } }),
                  _vm.taskForm.error_log_count > 0
                    ? _c(
                        "el-badge",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            cursor: "pointer"
                          },
                          attrs: { value: _vm.taskForm.error_log_count }
                        },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.onClickLogWithErrors }
                            },
                            [
                              _c("i", { staticClass: "el-icon-warning" }),
                              _vm._v(
                                " " + _vm._s(_vm.$t("Log with errors")) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.taskForm.type === "spider" &&
                  _vm.taskForm.status === "finished" &&
                  _vm.taskForm.result_count === 0
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "danger" }
                        },
                        [
                          _c("i", { staticClass: "el-icon-warning" }),
                          _vm._v(" " + _vm._s(_vm.$t("Empty results")) + " ")
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Execute Command") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Execute Command", disabled: "" },
                    model: {
                      value: _vm.taskForm.cmd,
                      callback: function($$v) {
                        _vm.$set(_vm.taskForm, "cmd", $$v)
                      },
                      expression: "taskForm.cmd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Parameters") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Parameters", disabled: "" },
                    model: {
                      value: _vm.taskForm.param,
                      callback: function($$v) {
                        _vm.$set(_vm.taskForm, "param", $$v)
                      },
                      expression: "taskForm.param"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Create Time") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.getTime(_vm.taskForm.create_ts),
                      placeholder: "Create Time",
                      disabled: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Start Time") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.getTime(_vm.taskForm.start_ts),
                      placeholder: "Start Time",
                      disabled: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Finish Time") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.getTime(_vm.taskForm.finish_ts),
                      placeholder: "Finish Time",
                      disabled: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Wait Duration (sec)") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.getWaitDuration(_vm.taskForm),
                      placeholder: "Wait Duration",
                      disabled: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Runtime Duration (sec)") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.getRuntimeDuration(_vm.taskForm),
                      placeholder: "Runtime Duration",
                      disabled: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Total Duration (sec)") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.getTotalDuration(_vm.taskForm),
                      placeholder: "Runtime Duration",
                      disabled: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Results Count") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Results Count", disabled: "" },
                    model: {
                      value: _vm.taskForm.result_count,
                      callback: function($$v) {
                        _vm.$set(_vm.taskForm, "result_count", $$v)
                      },
                      expression: "taskForm.result_count"
                    }
                  })
                ],
                1
              ),
              _vm.taskForm.status === "error"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Error Message") } },
                    [
                      _c("div", { staticClass: "error-message" }, [
                        _vm._v(" " + _vm._s(_vm.taskForm.error) + " ")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "button-container" },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "warning",
                icon: "el-icon-refresh"
              },
              on: { click: _vm.onRestart }
            },
            [_vm._v(" " + _vm._s(_vm.$t("Restart")) + " ")]
          ),
          _vm.isRunning
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "danger",
                    icon: "el-icon-video-pause"
                  },
                  on: { click: _vm.onStop }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Stop")) + " ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }